(function () {
    class ListOrderController {
        scope;
        filter;
        orderChannels = [];
        stores = [];
        orders = [];
        format;
        fromDateOptions;
        toDateOptions;
        grid = { hasError: false };
        orderTableParams;
        contextName;
        orderService;
        permissionService;
        localisationService;
        storesService;
        errorService;
        apiService;
        state;
        ngTableParams;
        compile;
        stateParams;
        uibModal;
        userContext;
        PayOnlineMethod = Dashboard.OrderPaymentType.PayOnline;
        dateTimeFormat;

        constructor(
            $scope,
            $filter,
            OrderService,
            PermissionService,
            LocalisationService,
            StoresService,
            ErrorService,
            APIService,
            $state,
            NgTableParams,
            $compile,
            $stateParams,
            $uibModal
        ) {
            this.scope = $scope;
            this.filter = $filter;
            this.scope.filter = {};
            this.scope.store = {};
            this.orderService = OrderService;
            this.permissionService = PermissionService;
            this.localisationService = LocalisationService;
            this.storesService = StoresService;
            this.errorService = ErrorService;
            this.apiService = APIService;
            this.state = $state;
            this.ngTableParams = NgTableParams;
            this.compile = $compile;
            this.stateParams = $stateParams;
            this.uibModal = $uibModal;
            this.userContext = this.permissionService.userContext;
            this.dateTimeFormat = LocalisationService.Configuration.DateTimeFilterFormat;
            this.contextName = this.userContext.getCurrentContextName();
            this.format = this.localisationService.DatePickerFormat;
            this.fromDateOptions = {
                formatYear: "yy",
                startingDay: 1,
                showWeeks: false,
                showDatePicker: false
            };
            this.toDateOptions = {
                formatYear: "yy",
                startingDay: 1,
                showWeeks: false,
                showDatePicker: false
            };
            this.momentDateFormat = "ddd MMM DD YYYY HH:mm:ss +0000";
            this.maxDateFilterBoundaryInDays = 7;
            this.loadCompleted = false;
            this.pageSize = 50;
            this.showMoreResultsButton = false;

            this.initialise();
        }

        defaultFromDateFilter() {
            const date = new Date();
            date.setHours(0);
            date.setMinutes(0);
            date.setSeconds(0);
            date.setMilliseconds(0);
            return date;
        }

        setFilter() {
            this.scope.filter.IsSuccess = this.state.params["IsSuccess"] || "";
            const channel = this.state.params["Channel"] || 0;
            this.scope.filter.Channel = parseInt(channel);
            this.scope.filter.CustomerName = this.state.params["CustomerName"] || "";
            this.scope.filter.MobileNumber = this.state.params["MobileNumber"] || "";

            if (this.userContext.isBrandContext()) {
                const storeId = this.state.params["Store"];
                this.scope.filter.Store = parseInt(storeId) || 0;
            }
            this.setDateFilters();
            this.setStoreAndBrandFilters();
            this.scope.filter.PageIndex = 1;
            this.scope.filter.PageSize = this.pageSize;
        }

        setDateFilters() {
            const fromDate = this.state.params["FromDate"] || this.defaultFromDateFilter();
            this.scope.filter.FromDate = moment(fromDate, this.momentDateFormat).toDate();
            this.scope.filter.ToDate = this.calculateFilterToDate(this.scope.filter.FromDate);
        }

        selectedFromDateExceedsLimit(fromDate) {
            const diffInDays = moment().diff(moment(fromDate), "days");
            const maximumDayDiff = this.maxDateFilterBoundaryInDays;
            return diffInDays >= maximumDayDiff;
        }

        setStoreAndBrandFilters() {
            const storeIdParam = this.state.params["StoreId"] || this.userContext.StoreId;
            const brandIdParam = this.state.params["BrandId"] || this.userContext.BrandId;
            this.scope.filter.StoreId = parseInt(storeIdParam) || null;
            this.scope.filter.BrandId = parseInt(brandIdParam) || null;
        }

        calculateFilterToDate(fromDate) {
            const to = this.selectedFromDateExceedsLimit(fromDate)
                ? moment(fromDate).add(this.maxDateFilterBoundaryInDays, "days")
                : moment(moment().add(1, "days").startOf("day"), this.momentDateFormat);
            return to.toDate();
        }

        async loadChannels() {
            const result = await this.orderService.getOrderChannels();
            let data = result.data;
            data.unshift({ Id: 0, Name: "Any" });
            data = result.data.filter((item) => {
                return item.Name !== "iOS" && item.Name !== "Android";
            });
            const cc = data.find((item) => item.Name === "CallCenter");
            if (cc) {
                cc.Name = "Call Center";
            }
            this.orderChannels = data;
        }

        setSelectedStore() {
            if (this.stores.length === 1) {
                this.scope.filter.StoreId = this.stores[0].Id;
            }
        }

        async fetchStoresForBrand() {
            const includeUnavailableStores = this.permissionService.doesUserHavePermissionForContext(
                Dashboard.Models.Lookups.Permissions.BrandCustomerSupportAgent)
            const result = await this.storesService.getStoresForBrand(
                this.userContext.BrandId,
                false,
                includeUnavailableStores);
            result.data.Stores.unshift({ Id: 0, Name: "All" });
            this.stores = result.data.Stores;
            this.setSelectedStore();
        }

        async fetchStoresForCallCenter() {
            const result = await this.storesService.getStoresForCallCenter(this.userContext.CallCenterId);
            // The fields in the stores we get from this endpoint are not named properly.
            const stores = [];
            result.data.forEach((dataStore) => {
                stores.push({ Id: dataStore.StoreId, Name: dataStore.StoreName });
            });
            this.stores = stores;
            this.setSelectedStore();
        }

        async loadStores() {
            // Check if we should even load the stores.
            if (!this.shouldShowStoreSelector()) {
                return;
            }
            // Check which context we are in so we can fetch the appropriate stores.
            if (this.userContext.isBrandContext()) {
                await this.fetchStoresForBrand();
            } else if (this.userContext.isCallCenterContext()) {
                await this.fetchStoresForCallCenter();
            }
        }

        async initialise() {
            this.setupWatchers();
            this.checkUserAccessToOrders();
            this.setFilter();
            await this.loadChannels();
            await this.loadStores();

            if (!this.userContext) {
                this.grid.hasError = true;
                return;
            }
            this.setupTable();
        }

        isEmpty = obj => [Object, Array].includes((obj || {}).constructor) && !Object.entries((obj || {})).length;

        setupWatchers() {
            this.scope.$watch("filter", (newValue) => {
                this.state.go(this.state.current.name, newValue, {notify: false});
            }, true);

            this.scope.$watch("store", (newValue) => {
                let selectedStoreId = 0;
                if (!this.isEmpty(newValue)) {
                    selectedStoreId = newValue.selected;
                }
                this.scope.filter.Store = selectedStoreId;
            }, true);
        }

        formatFilterData(filter) {
            filter.ToDate = this.calculateFilterToDate(filter.FromDate);
            // Format the dates so they are sent as UTC
            if (filter.ToDate) {
                filter.ToDate = filter.ToDate.toISOString();
            }
            if (filter.FromDate) {
                filter.FromDate = moment.utc(filter.FromDate).toISOString();
            }
        }

        onFilterButtonClicked() {
            void this.filterOrders();
        }

        onNextButtonClicked() {
            void this.nextPage();
        }

        async filterOrders() {
            const filter = this.prepareFilter();
            this.loadCompleted = false;
            this.showMoreResultsButton = false;
            try {
                const result = await this.fetchOrdersFor(filter);
                this.updatedOrderListAndReloadTable(
                    [],
                    result.data.Orders);
                this.setShowMoreResultsVisibility(result.data.Orders.length);
            } catch(error) {
                this.errorService.showError("An error occurred when loading the orders", error);
            }
            this.loadCompleted = true;
        }

        async nextPage() {
            this.scope.filter.PageIndex = this.scope.filter.PageIndex + 1;
            const filter = this.prepareFilter();
            this.loadCompleted = false;
            try {
                const result = await this.fetchOrdersFor(filter);
                const resultLength = result.data.Orders.length;
                this.setShowMoreResultsVisibility(resultLength);
                if (!resultLength) {
                    return;
                }
                this.updatedOrderListAndReloadTable(
                    this.orders,
                    result.data.Orders);
            } catch (error) {
                this.errorService.showError("An error occurred when loading the orders", error);
            }
            this.loadCompleted = true;
        }

        setShowMoreResultsVisibility(resultLength) {
            const noMoreResults = !resultLength || resultLength < this.pageSize;
            this.showMoreResultsButton = !noMoreResults;
        }

        prepareFilter() {
            const filter = Object.assign({}, this.scope.filter);
            this.formatFilterData(filter);
            return filter;
        }

        updatedOrderListAndReloadTable(originalOrders, orders) {
            this.orders = this.uniqueOrdersFor(
                originalOrders,
                orders);
            this.reloadTable();
        }

        reloadTable() {
            Dashboard.helpers
                .tableHelper
                .reloadTable(
                    this.orderTableParams,
                    this.orders,
                    true);
        }

        async fetchOrdersFor(filter) {
            return await this.orderService.getOrdersForContext(
                filter,
                this.userContext);
        }

        uniqueOrdersFor(original, orders) {
            return [
                ...new Map([
                    ...original,
                    ...orders
                ]
                .map((item) => [item["Id"], item]))
                .values()
            ];
        }

        canRefundCardOrVoucherPayment(order) {
            const hasPermissionToRefundOrder = this.canRefund();
            const orderIsSuccessful =
                (order.CardPaymentStateId === Dashboard.CreditCardPaymentStates.Paid
                    || order.VoucherStateId === Dashboard.VoucherStatus.Redeemed);

            return hasPermissionToRefundOrder && orderIsSuccessful;
        }

        canRefund() {
            return this.permissionService
                .doesUserHavePermissionForContext(Dashboard.Models.Lookups.Permissions.ActionRefunds,
                    this.userContext);
        }

        goToOrder(orderId) {
            if (this.permissionService.userContext.isBrandContext()) {
                this.state.go("app.brandorders.vieworder", {
                    id: orderId,
                    brandId: this.userContext.BrandId
                });
            } else if (this.permissionService.userContext.isStoreContext()) {
                this.state.go(".vieworder", {
                    id: orderId,
                    storeId: this.userContext.StoreId
                });
            }
        }

        showRefundModal(order) {
            const callback = () => this.filterOrders();
            this.uibModal.open({
                animation: true,
                templateUrl: "components/orders/vieworder/orderrefundmodal.61e53758.html",
                controller: "OrderRefundModalController",
                size: "lg",
                backdrop: "static",
                resolve: {
                    orderGuid: function () {
                        return order.OrderGuid;
                    },
                    callback: function () {
                        return callback;
                    }
                }
            });
        }

        showNoResults() {
            return this.orders.length === 0 && this.loadCompleted;
        }

        showDateLimitNotification() {
            const diff = moment().startOf("day").diff(moment(this.scope.filter.FromDate), "days");
            return ((diff + 1) > this.maxDateFilterBoundaryInDays) && this.loadCompleted;
        }

        setupTable() {
            const filter = this.filter;
            this.orderTableParams = new this.ngTableParams({
                page: 1,
                count: Infinity
            }, {
                counts: [],
                getData: (params) => {
                    return Dashboard.helpers.tableHelper
                        .sortAndFilter(
                            params,
                            filter,
                            this.orders);
                }
            });
        }

        checkUserAccessToOrders() {
            if (!this.permissionService.doesUserHavePermissionForContext("OrdersAccess", this.userContext)) {
                this.permissionService.navigateToAccessDenied();
            }
        }

        openFromDatePicker() {
            this.fromDateOptions.showDatePicker = true;
        }

        openToDatePicker() {
            this.toDateOptions.showDatePicker = true;
        }

        shouldShowStoreSelector() {
            return this.userContext.isBrandContext() ||
                this.userContext.isCallCenterContext();
        }

        shouldShowRestaurantFilter() {
            const isBrandContext = this.userContext.isBrandContext();
            const doesHavePermissions = this.permissionService
                .doesUserHavePermissionForContext(
                    Dashboard.Models.Lookups.Permissions.BrandCustomerSupportAgent,
                    this.userContext);
            return isBrandContext && doesHavePermissions;
        }
    }

    angular
        .module("dashboard")
        .component("listOrders",
            {
                templateUrl: "components/orders/listorders/listorders.477808a0.html",
                bindings: {},
                controller: [
                    "$scope",
                    "$filter",
                    "OrderService",
                    "PermissionService",
                    "LocalisationService",
                    "StoresService",
                    "ErrorService",
                    "APIService",
                    "$state",
                    "NgTableParams",
                    "$compile",
                    "$stateParams",
                    "$uibModal",
                    ListOrderController]
            });
})();
